import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { api } from "./api";
import { chat } from "./chat";
import { local } from "./local";
import { persist } from "./persist";
import { playbook } from "./playbook";

export const store = configureStore({
  middleware: (m) => m().prepend(persist.middleware).concat(api.middleware),
  reducer: {
    api: api.reducer,
    chat: chat.reducer,
    local: local.reducer,
    playbook: playbook.reducer,
  },
});

type State = ReturnType<typeof store.getState>;
type Dispatch = typeof store.dispatch;

export const useTypedSelector = useSelector.withTypes<State>();
export const useTypedDispatch = useDispatch.withTypes<Dispatch>();
